import { Outlet, useLocation } from 'react-router-dom'
import { VisualEditing } from '@sanity/visual-editing/react-router'
import { Footer } from '@autoplan/web-ui'
import TemporaryHeader from '../public/temporary-header.png'
import { useHomeContent, urlFor, useBrandSettings } from '@autoplan/web-sanity'

function Layout({ withoutSidebarPadding = false }: { withoutSidebarPadding?: boolean }) {
  const content = useHomeContent()
  const { logoUrl } = useBrandSettings()
  const { pathname } = useLocation()
  const isHome = pathname === '/'

  const headerSrc = content?.page?.headerImage
    ? (urlFor(content.page.headerImage)?.width(1600).height(350).url() ?? TemporaryHeader)
    : TemporaryHeader

  return (
    <div className="ap:relative ap:text-content-primary ap:w-full ap:min-h-screen ap:flex ap:flex-col">
      {isHome && (
        <div className="ap:absolute ap:w-full ap:h-[350px] ap:overflow-hidden ap:pointer-events-none ap:shrink-0 ap:-z-10">
          <img src={headerSrc} alt="" className="ap:w-full ap:h-full ap:object-cover ap:object-top" />
          <div className="ap:absolute ap:inset-0 ap:bg-linear-to-b ap:from-transparent ap:to-surface-background" />
        </div>
      )}
      <div className={`ap:flex ap:flex-1 ap:flex-col ap:w-full${isHome && !withoutSidebarPadding ? ' ap:pl-6xl' : ''}`}>
        {logoUrl && (
          <div className="ap:px-2xl ap:pt-2xl">
            <img src={logoUrl} alt="Logo" className="ap:h-5xl ap:w-auto ap:object-contain" />
          </div>
        )}
        <div className={`ap:flex-1 ap:max-w-[2100px] ap:px-2xl${isHome ? ' ap:mt-[190px]' : ' ap:mt-2xl'}`}>
          <Outlet />
        </div>
        <div className="ap:max-w-[2100px] ap:px-2xl">
          <Footer />
        </div>
      </div>
      <VisualEditing />
    </div>
  )
}

export default Layout
